import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

interface ReservedFundsBonusModalProps {
  walletId: string
}

export const ReservedFundsBonusModal: BaseModalType<ReservedFundsBonusModalProps> = (props) => {
  const { close, walletId } = props
  const apiClient = useApiClient(ClientApiClient)

  const { t } = useTranslation()

  const { data: options, isLoading } = useQuery({
    queryKey: queryKeys.walletExtended.activeBonus(walletId),
    queryFn: () => apiClient.getActiveBonus(walletId),
    enabled: !!walletId,
  })

  return (
    <Modal>
      <Modal.Header>{t('Wallet.Reserved funds for Bonus')}</Modal.Header>
      <Modal.Body isLoading={isLoading}>
        <Modal.Body.ListGroup
          groups={options?.items?.map((option) => [
            { label: t('Reference'), value: option.referenceId },
            { label: t('Wallet.Bonus amount'), value: option.amount },
            { label: t('Wallet.Bonus reserved'), value: option.bonusReserved },
            { label: t('Wallet.Lots required'), value: option.lotsRequired },
            { label: t('Wallet.Lots traded'), value: option.lotsTraded },
          ])}
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Close')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
